import { call, put, takeLatest } from 'redux-saga/effects';
import { aiNoteService } from './aiNote.service';
import {
    GENERATE_AI_SESSION_NOTE,
    GENERATE_AI_SESSION_NOTE_FAIL,
    GENERATE_AI_SESSION_NOTE_SUCCESS,
} from './aiNote.type';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';

function* generateAiSessionNote(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(aiNoteService.generateSessionNote, action.payload.apptId, action.payload.formId);
        yield put({ type: GENERATE_AI_SESSION_NOTE_SUCCESS, payload: res.data });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put({ type: GENERATE_AI_SESSION_NOTE_FAIL, payload: err?.data?.message || 'AI generation failed' });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(
            httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message || 'AI generation failed'),
        );
    }
}

export const watchAiNote = function* watchAiNoteSaga() {
    yield takeLatest(GENERATE_AI_SESSION_NOTE, generateAiSessionNote);
};
